import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import AssemblerCard from "./assembler/AssemblerCard";
import {isEmpty, parseDate} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import ControllerFWVersionCard from "./assembler/ControllerFWVersionCard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {ASSEMBLY_STATUS_COLOR, ON_PROGRESS, OPEN, QC_RETURNED} from "enqc-utilities/src/utils/Global";
import {getUser} from "../utils/StorageUtil";
import Endpoint from "enqc-utilities/src/api/Endpoint";

export default class AssemblyDetailModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly, show} = this.props
        if(!assembly){
            assembly = {}
        }
        this.state = {
            assembly:assembly?assembly:{},
            adminPerformer:{},
            show:show
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly,show} = nextProps
            if(!assembly){
                assembly = {}
            }
            this.setState({assembly,show},async () => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                    await this.fetchAdminInformation(this.props)
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    async fetchAdminInformation(props){
        let {assembly} = props
        if(!assembly || !assembly.id){
            return
        }
        let params = {params:{assemblyId:assembly.id}}
        let response = await this.asyncGet(Endpoint.API.ASSEMBLY_STATUS_HISTORY_LAST_ONE, params, null, true, true);
        if(response.code===200){
            let {data} = response
            if(!data){
                data = {}
            }
            let {adminPerformer} = data
            if(!adminPerformer){
                adminPerformer = {}
            }
            this.setState({adminPerformer})
            return response ;
        }
    }


    render() {
        let {assembly, adminPerformer, show} = this.state
        let {user} = assembly
        if(!user){
            user = {}
        }
        let assemblyStatus = assembly.assemblyStatus
        if(isEmpty(assemblyStatus)){
            assemblyStatus = {}
        }
        let {statusMessage} = assembly

        let mine = getUser()

        let statusButtonDisable = true ;
        if(assemblyStatus.id===ON_PROGRESS && user.id==mine.id){
            statusButtonDisable = false ;
        }else if(assemblyStatus.id===OPEN){
            statusButtonDisable = false ;
        }else if(assemblyStatus.id===QC_RETURNED){
            statusButtonDisable = false ;
        }

        let {serialComponent} = assembly
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components){
            components = []
        }

        let {rectifierControllerEntry} = assembly
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = []
        }
        let {onContinueAssembly} = this.props
        if(!onContinueAssembly){
            onContinueAssembly = () => {}
        }
        let model = assembly.model??{}
        let modelCategory = model.modelCategory??{}

        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.AssemblyDetail} - {label.Updated} @({parseDate(assembly.updated, DD_MMMM_YYYY_HH_MM_SS)})</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <Row>
                            <Col md={4} className="mb-3">
                                <Row>
                                    <Col>
                                        <AssemblerCard
                                            user={user}
                                            showProcessing={this.props.showProcessing}
                                            closeProcessing={this.props.closeProcessing}/>
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        <Card>
                                            <Card.Body>
                                                <Row>
                                                    <Col>
                                                        {label.Model}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <span className="bold font-medium text-danger"><h4>{model.systemType}</h4></span>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {label.PartNumber}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <span className="bold font-small text-success"><h4>{model.partNumber}</h4></span>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {label.Category}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <span className="font-weight-bolder font-medium"><h5>{modelCategory.name}</h5></span>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card>
                                            <Card.Body>
                                                <Row>
                                                    <Col>
                                                        {label.Status}
                                                        <br/>
                                                        <span><h3 style={{color:ASSEMBLY_STATUS_COLOR[assemblyStatus.name]}}>{assemblyStatus.name?assemblyStatus.name:label.Status}</h3></span>
                                                    </Col>
                                                </Row>
                                                {statusMessage&&(
                                                    <React.Fragment>
                                                        <Row>
                                                            <Col>
                                                                <span className="fw-bolder">{label.Message} {adminPerformer.firstname?label.From+": "+adminPerformer.firstname:""}</span>
                                                                <br/>
                                                                <span><h5 style={{color:'red'}}>{statusMessage}</h5></span>
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>
                                                )}
                                                <Row>
                                                    <Col>
                                                        {!statusButtonDisable&&(
                                                            <Button
                                                                variant="white"
                                                                className={"d-block w-100 "+(statusButtonDisable?"btn-outline-gray":"btn-outline-success")}
                                                                disabled={statusButtonDisable}
                                                                onClick={(event) => {
                                                                    event.preventDefault()
                                                                    // this.setState({continueAssemblyConfirmationModal:true})
                                                                    onContinueAssembly(assembly)
                                                                }}>
                                                                {label.Continue}
                                                                &nbsp;
                                                                <FontAwesomeIcon icon={faArrowRight} size="sm" />
                                                            </Button>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={8} className="mb-3">
                                <Row>
                                    <Col>
                                        <ControllerFWVersionCard
                                            headerClassName={"p-2"}
                                            assembly={assembly}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Card size="sm" className="p-0">
                                            <Card.Header className="p-2">
                                                {label.Component}
                                            </Card.Header>
                                            <Card.Body className="p-0">
                                                <Table responsive className="table-sm align-items-center table-flush">
                                                    <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col" style={{width:'7%'}} className="ps-1 pe-1">#</th>
                                                        <th scope="col" style={{width:'60%'}} className="text-left text-wrap">{label.Label}</th>
                                                        <th scope="col" className="text-left">{label.Value}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {components.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td style={{width:'7%'}} className="ps-1 pe-1">{index+1}</td>
                                                                <td className="text-left text-wrap p-0text-black fw-bolder" style={{width:'60%'}}>
                                                                    {item.label}
                                                                </td>
                                                                <td className="text-left text-wrap">
                                                                    {item.value}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </Table>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <br/>
                                <Row>
                                    <Col>
                                        <Card size="sm" className="p-0">
                                            <Card.Header className="p-2">
                                                {label.RectifierSerialNumber}
                                            </Card.Header>
                                            <Card.Body className="p-0">
                                                <Table responsive className="table-sm align-items-center table-flush">
                                                    <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col" style={{width:'7%'}} className="ps-1 pe-1">{label.Order}</th>
                                                        <th scope="col" className="text-left">{label.Value}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {rectifierControllerSerialNumbers.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center text-black font-small ps-1 pe-1" style={{width:'7%'}}>
                                                                    #{item.indexOrder}
                                                                </td>
                                                                <td className="text-left">
                                                                    {item.serialCode}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </Table>

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
AssemblyDetailModal.propTypes = {
    assembly:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onContinueAssembly:PropTypes.func,

}
